// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FinectLogoPlus } from '@finect/tabular-components/FinectLogoPlus';
import { HeroContainer, HeroWrapper, WelcomeText, NavBar, NavItem, Logo } from './partials';

const sections = [
  { id: 'seleccion', tab: 'Mi Selección', metaTitle: 'Mi Selección', to: '/plus/seleccion' },
  { id: 'analisis', tab: 'Análisis', metaTitle: 'Análisis', to: '/plus/analisis' },
  { id: 'herramientas', tab: 'Herramientas', metaTitle: 'Herramientas', to: '/plus/herramientas' },
  { id: 'formacion', tab: 'Formación', metaTitle: 'Formación' }
];

type Props = {
  user?: Object,
  activeTab?: string,
  withHello?: boolean
};

export const PlusHero = (props: Props) => {
  const omninavState: 'opened' | 'closed' = useSelector(state => state.omninav.state);
  const linkProps = {
    rel: 'nofollow'
  };

  // coger la primera palabra del nombre del usuario (si tiene menos de 3 palabras)
  // o las dos primeras palabras (si tiene más de 3 palabras)
  const userName = props.user?.name || '';
  const nameParts = userName.split(' ');
  const name = nameParts.length > 3 ? `${nameParts[0]} ${nameParts[1]}` : nameParts[0];

  return (
    <HeroContainer $withHello={props.withHello} omninavState={omninavState}>
      <HeroWrapper>
        <div>
          {props.withHello ? (
            <WelcomeText>
              <strong>Hola,</strong> {name}
            </WelcomeText>
          ) : (
            <div></div>
          )}

          <Logo>
            <FinectLogoPlus />
          </Logo>
        </div>

        <NavBar>
          {sections.map((section, index) => (
            <NavItem
              key={index}
              $active={props?.activeTab === section.id}
              {...linkProps}
              {...(section.to && { as: Link, to: section.to })}
            >
              {section.tab}
            </NavItem>
          ))}
        </NavBar>
      </HeroWrapper>
    </HeroContainer>
  );
};
